// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { setDisclaimerConsent } from 'actions/site'

class DisclaimerConsent extends React.Component {
	maxAge = 60 * 60 * 24 * 365 * 3 // 3 years.

	handleAccept = () => {
		const { dispatch } = this.props

		document.cookie = `disclaimer_consent=1;max-age=${this.maxAge};path=/`

		dispatch( setDisclaimerConsent( 1 ) )
	}

	handleRefuse = () => {
		document.cookie = `disclaimer_consent=0;max-age=${this.maxAge};path=/`

		dispatch( setDisclaimerConsent( 0 ) )
	}

	render() {
		const { disclaimerConsent, inGdprZone } = this.props

		// disclaimerConsent:
		// null - not set.
		// 0 - consent denied.
		// 1 - consent given.
		if ( null !== disclaimerConsent ) {
			return null
		}

		return (
			<div className="disclaimer-consent">
				<div className="-inner">
					<div className="-image">
						<img src={ `${siteData.images_url}cross/cross.svg` } alt="" />
					</div>

					<div className="-text">
						<p>
							Aboriginal and Torres Strait Islander viewers are advised that photographs and videos on this website may contain images of persons deceased.
						</p>

						<div className="-actions">
							<div className="button -accept is-small" onClick={ this.handleAccept }>
								Accept and continue
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		disclaimerConsent: state.site.disclaimerConsent
	}
}

export default connect( mapStateToProps )( DisclaimerConsent )



// WEBPACK FOOTER //
// ./components/DisclaimerConsent/DisclaimerConsent.jsx